// extracted by mini-css-extract-plugin
export var Description = "F_cg";
export var EditorialGuidelines = "F_cb";
export var GuideLines = "F_ch";
export var Title = "F_cf";
export var container = "F_cc";
export var leftColumn = "F_cd";
export var rightColumn = "F_cj";